import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServicesCards from "./ServicesCards";
import { FaServer, FaCloud, FaDocker, FaCodeBranch, FaLaptopCode, FaShieldAlt, FaGlobe } from 'react-icons/fa';
import { SiAnsible, SiKubernetes } from "react-icons/si";

function Services() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Our <strong className="red">Services </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few of the services we provide.
        </p>
        <p style={{ color: "white" }}>
          If your specific requirements aren’t listed, don’t hesitate to connect with us for a tailored solution.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaLaptopCode />}
              isBlog={false}
              title="Website Development"
              description="We create modern, responsive websites tailored for small businesses. Whether you're looking for a marketing site, e-commerce platform, or internal tool, we’ll build it to fit your brand and needs."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaGlobe />}
              isBlog={false}
              title="Web Hosting & Domain Management"
              description="Reliable hosting and full domain management services. From DNS configuration to SSL certificates, we ensure your online presence is secure and always available."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaCodeBranch />}
              isBlog={false}
              title="Custom Application Development"
              description="We build secure, scalable applications for businesses — from internal tools to customer-facing apps — using modern technologies tailored to your operations."            
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaServer />}
              isBlog={false}
              title="Server Management"
              description="Our team manages your servers (Linux/Windows) with 24/7 monitoring, backups, patching, and optimization. Minimize downtime and maximize performance across cloud or on-prem systems."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaCloud />}
              isBlog={false}
              title="Cloud Infrastructure & Virtualization"
              description="We design, deploy, and manage cloud infrastructure using AWS, Azure, or Proxmox. Our solutions support high availability, backup strategies, and resource optimization."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaShieldAlt />}
              isBlog={false}
              title="Security & Compliance Services"
              description="From vulnerability assessments to NIST 800-171 compliance, we help secure your systems and provide actionable reporting. We also assist with audits and policy creation."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<SiKubernetes />}
              title="Kubernetes Deployments"
              description="Automated deployment, scaling, and management of containerized applications using Kubernetes. Ensures high availability, self-healing, and smooth rollouts for your workloads."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<FaDocker />}
              title="Containerization of Custom Apps"
              description="Package your applications into portable containers for consistent development, testing, and production environments. Supports Docker, Podman, and other container runtimes."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCards
              icon={<SiAnsible />}
              title="Configuration Management Automation"
              description="Automate system configuration, application deployment, and task execution across servers using Ansible. Ensures consistent environments, reduces manual errors, and accelerates IT operations."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Services;
